import * as React from 'react';

const MenuDonations = () => (
  <svg
    width={28}
    height={25}
    viewBox="0 0 28 25"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    fill="#677BC5">
    <path
      fill="#FFFFFF"
      d="M5.5,16 L5.5,14 L21,14 L21,16 L5.5,16 Z M6.5,25 L6.5,17.5 L20,17.5 L20,25 L6.5,25 Z"
    />
    <path
      fill="#1C1F34"
      d="M15.56,19.465 C14.973,18.845 14.022,18.845 13.435,19.465 L13.25,19.66 L13.065,19.465 C12.478,18.845 11.527,18.845 10.94,19.465 C10.353,20.084 10.353,21.088 10.94,21.708 L11.125,21.903 L12.833,23.706 C13.063,23.95 13.437,23.95 13.667,23.706 L15.375,21.903 L15.56,21.708 C16.147,21.088 16.147,20.084 15.56,19.465"
    />
    <path d="M4,16.982 C4,17.397 5,17.733 5,17.733 L5,25 L1,25 L1,14 L4,14 L4,16.982 Z M0,10 L12.76,10 C12.451,10.889 12.043,11.921 11.736,12.5 L0,12.5 L0,10 Z" />
    <path d="M14.663,8.772 C14.705,8.316 14.7,7.878 14.627,7.475 C14.648,7.085 15.109,6.437 16.687,6.27 C17.429,7.303 19.006,8.315 22.338,10.152 C28,13.273 28,16.295 28,20.869 C28,24.833 24.832,24.995 24.478,25 L21.5,25 L21.5,17.5 C21.5,17.5 22.5,17.164 22.5,16.75 L22.5,13.355 C22.5,12.941 22.064,12.5 21.652,12.5 L13.409,12.5 C13.714,11.867 14.071,11.144 14.331,10.273 C14.357,10.19 14.614,9.183 14.663,8.772 Z M11.173,5.137 C10.888,5.088 10.492,5.021 10.262,4.948 C10.435,4.584 11.083,3.982 11.789,3.545 L12.288,4.05 C12.58,4.344 13.051,4.344 13.343,4.053 C13.635,3.76 13.636,3.285 13.346,2.991 L12.251,1.884 C12.273,1.518 13.422,0.447 15.202,0.081 C16.153,-0.113 16.692,0.076 16.982,0.277 C16.563,0.862 16.042,1.91 16.042,3.499 C16.042,4.005 16.057,4.441 16.118,4.836 C14.888,5.04 14.163,5.513 13.739,6.011 C12.995,5.45 11.956,5.271 11.173,5.137 Z" />
  </svg>
);

export default MenuDonations;



// WEBPACK FOOTER //
// ./src/assets/images/icons/menu-donations.js